import {Component} from 'react'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'

import {generate} from '../../../../routes.js'
import conf from '../../../../conf.js'
import sharedConf from '../../../../../shared/conf.js'
import DefaultLayout from '../../../Layout/DefaultLayout.jsx'
import Loader from '../../../../../shared/components/Loader/Loader.jsx'
import SearchResultsPaginated from '../../../Search/Components/SearchResultsPaginated.jsx'
import SubscribeBanner from '../../../../components/SubscribeBanner/SubscribeBanner.jsx'
import OfferSearchActiveFilters from './Components/OfferSearchActiveFilters.jsx'
import OfferSearchCard from './Components/OfferSearchCard.jsx'
import OfferSearchFilterSidebar from './Components/OfferSearchFilterSidebar.jsx'
import OfferSearchSidePanel from './Components/OfferSearchSidePanel.jsx'
import OfferSearchTopbar from './Components/OfferSearchTopbar.jsx'
import OfferAnswerModal from '../../../../components/Modals/OfferAnswerModal/OfferAnswerModal.jsx'
import MessageModal from '../../../../../shared/components/Modals/MessageModal/MessageModal.jsx'
import connectModal from '../../../../../shared/components/Modals/connect.js'

import './OfferSearchResults.scss'

class OfferSearchResults extends Component {
  static propTypes = {
    currentUniverseId: PropTypes.number,
    currentUser: PropTypes.object,
    flattenSearchObject: PropTypes.func.isRequired,
    freelance: PropTypes.object,
    isAdmin: PropTypes.bool.isRequired,
    loading: PropTypes.bool,
    search: PropTypes.func.isRequired,
    searchData: PropTypes.object,
    searchQuery: PropTypes.object.isRequired,
    searchRouteName: PropTypes.string.isRequired,
    searchTarget: PropTypes.string.isRequired,
    userMainUniverseId: PropTypes.number,
  }

  static defaultProps = {
    currentUniverseId: null,
    userMainUniverseId: null,
  }

  static topologies = [
    [
      {name: 'filled', label: 'Pourvue', value: conf.search.topologies.offers.filled},
      {name: 'not_filled', label: 'Non pourvue', value: conf.search.topologies.offers.notFilled}
    ],
    [
      {name: 'published', label: 'Publiée', value: conf.search.topologies.offers.published},
      {name: 'not_published', label: 'Non publiée', value: conf.search.topologies.offers.notPublished}
    ],
    [
      {name: 'locked', label: 'Verrouillée', value: conf.search.topologies.offers.locked},
      {name: 'not_locked', label: 'Non verrouillée', value: conf.search.topologies.offers.notLocked}
    ],
  ]

  static filters = {
    orders: [
      {
        name: 'publication_sort',
        label: 'Publication',
        tooltip: 'Tri sur la date de publication',
        mustBeAdmin: true,
      },
      {
        name: 'filled_sort',
        label: 'Provision',
        tooltip: 'Tri sur la date de provision',
        mustBeAdmin: true,
      },
      {
        name: 'created_sort',
        label: 'Création',
        tooltip: 'Tri sur la date de création',
        mustBeAdmin: true,
      }
    ],
    adminOnlyRequirements: false,
    requirementChoices: [
      {text: 'Défaut'},
      {value: 1, text: 'ID (Sans le #)'},
    ]
  }

  state = {
    selectedIndex: null,
    answeredOfferIds: {},
  }

  componentDidUpdate(prevProps) {
    if (prevProps.searchData?.results !== this.props.searchData?.results) {
      this.setState({selectedIndex: null, answeredOfferIds: {}})
    }
  }

  generateLink = (search, offset) => generate({
    name: 'offers.search.viewer.views',
    parameters: {offset, page: this.props.searchQuery.page},
    search: search
  })

  expandOffer = (offer) => {
    const justAnswered = !!this.state.answeredOfferIds[offer.id]

    return {
      ...offer,
      city: Array.isArray(offer.city) ? offer.city : [offer.city],
      keywords: offer.keywords ? offer.keywords.map(keyword => ({name: keyword})) : [],
      secteurs: offer.secteurs ? offer.secteurs.map(secteur => ({name: secteur})) : [],
      hasAnswer: offer.hasAnswer || justAnswered,
      nbOfferAnswer: justAnswered ? (offer.nbOfferAnswer ?? 0) + 1 : offer.nbOfferAnswer,
    }
  }

  handleSelectOffer = (index) => {
    this.setState({selectedIndex: index})
  }

  handleCloseSidePanel = () => {
    this.setState({selectedIndex: null})
  }

  handlePrevOffer = () => {
    const total = this.props.searchData?.results?.length ?? 0
    if (!total) return
    this.setState((prevState) => ({selectedIndex: (prevState.selectedIndex - 1 + total) % total}))
  }

  handleNextOffer = () => {
    const total = this.props.searchData?.results?.length ?? 0
    if (!total) return
    this.setState((prevState) => ({selectedIndex: (prevState.selectedIndex + 1) % total}))
  }

  canApplyForJob = (offer) => {
    const {currentUser, isAdmin} = this.props

    if (!currentUser || !currentUser.cgu_accepted) {
      return false
    }

    if (
      currentUser.account_type === sharedConf.accountTypes.freelance &&
      currentUser.mainUniverse === offer.universe &&
      !offer.hasAnswer && !offer.filled && !offer.locked
    ) {
      return true
    }

    return !!isAdmin
  }

  applyForJob = (offer) => {
    if (this.props.currentUser?.complete) {
      this.props.openOfferAnswerModal({
        user: this.props.currentUser,
        freelance: this.props.freelance,
        offer,
        answer: {},
        onClose: () => {
          this.setState((prevState) => ({
            answeredOfferIds: {...prevState.answeredOfferIds, [offer.id]: true},
          }))
          this.props.search(this.props.searchQuery)
        }
      })
    } else {
      this.props.openMessageModal({
        title: 'Vous n\'avez pas finalisé votre inscription',
        message: 'Vous devez finaliser votre inscription avant de postuler à une annonce',
        actions: [
          {
            text: 'Fermer',
            className: 'btn-primary',
            onClick: (modal) => {
              modal.toggle()
            }
          }
        ]
      })
    }
  }

  goToEdit = (offer) => {
    const {searchQuery} = this.props
    this.props.history.push(generate({
      name: 'offers.search.viewer.edit',
      parameters: {offer: offer.id, offset: this.state.selectedIndex, page: searchQuery.page},
      search: this.props.flattenSearchObject(searchQuery),
    }))
  }

  renderOffers = (offers) => {
    const {selectedIndex} = this.state

    return (
      <div className="dashboard-search-offer__results">
        {offers.map((offer, index) => (
          <OfferSearchCard
            isAdmin={this.props.isAdmin}
            key={offer.id}
            offer={this.expandOffer(offer)}
            selected={selectedIndex === index}
            onOpen={() => this.handleSelectOffer(index)}
          />
        ))}
      </div>
    )
  }

  render() {
    const {
      currentUniverseId, currentUser, isAdmin, loading, searchData, searchQuery,
      searchRouteName, searchTarget, userMainUniverseId,
    } = this.props
    const {selectedIndex} = this.state

    const results = searchData?.results?.length ? searchData.results : []
    const isOnlyMy = !!currentUser && !isAdmin && !!currentUser?.complete
    const isCity = {all: true, remote: false}
    const selectedOffer = selectedIndex !== null && results[selectedIndex] ? this.expandOffer(results[selectedIndex]) : null
    const flattenedSearch = this.props.flattenSearchObject(searchQuery)

    return (
      <DefaultLayout navbarContained={false} navbarSearch={false} showStickyPhone={false}>
        <div className="container-fluid container-search-offer">
          <div className="row row-search-offer">
            <OfferSearchFilterSidebar
              currentUniverseId={currentUniverseId}
              filters={OfferSearchResults.filters}
              isAdmin={isAdmin}
              isCity={isCity}
              isManager={true}
              isOnlyMy={isOnlyMy}
              onChange={this.props.search}
              searchQuery={searchQuery}
              topologies={OfferSearchResults.topologies}
              userMainUniverseId={userMainUniverseId}
            />

            <div className="container dashboard-search-offer">
              <OfferSearchActiveFilters
                isAdmin={isAdmin}
                isManager={true}
                isOnlyMy={isOnlyMy}
                onChange={this.props.search}
                requirementChoices={OfferSearchResults.filters.requirementChoices}
                searchQuery={searchQuery}
                topologies={OfferSearchResults.topologies}
              />

              <OfferSearchTopbar
                onChange={this.props.search}
                searchQuery={searchQuery ?? {}}
                filters={OfferSearchResults.filters}
                isAdmin={isAdmin}
                isManager={true}
                resultsCount={searchData?.pagination?.totalCount ?? 0}
              />

              <SubscribeBanner
                currentUser={currentUser}
                search={this.props.search}
                searchUniverseId={null}
                target={searchTarget}
              />

              {loading ? (
                <div className="p-5 p-relative">
                  <Loader visible={true} fill={false} contains={true} containsClassName="my-5">
                    Recherche en cours...
                  </Loader>
                </div>
              ) : (
                <SearchResultsPaginated
                  className="search-results"
                  flattenSearchObject={this.props.flattenSearchObject}
                  pagination={searchData?.pagination ?? {}}
                  renderResults={this.renderOffers}
                  results={results}
                  routeName={searchRouteName}
                  searchQuery={searchQuery}
                  selectedIndex={selectedIndex}
                />
              )}
            </div>

            {selectedOffer && (
              <OfferSearchSidePanel
                offer={selectedOffer}
                isAdmin={isAdmin}
                index={selectedIndex}
                total={results.length}
                canApply={this.canApplyForJob(selectedOffer)}
                canEdit={!!isAdmin}
                fullLink={this.generateLink(flattenedSearch, selectedIndex)}
                onApply={this.applyForJob}
                onEdit={this.goToEdit}
                onPrev={this.handlePrevOffer}
                onNext={this.handleNextOffer}
                onClose={this.handleCloseSidePanel}
              />
            )}
          </div>
        </div>
      </DefaultLayout>
    )
  }
}

export default connect(
  (state) => ({
    currentUniverseId: state.universe?.currentUniverse?.id ?? null,
    freelance: state.currentUser.freelance,
    searchData: state.search,
    userMainUniverseId: state.currentUser?.user?.mainUniverse ?? null,
  }),
)(connectModal({OfferAnswerModal, MessageModal}, OfferSearchResults))
